import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class PochtaSearchOpsRequestQuery
*  Query params for operation "PochtaSearchOps"
*/
export class PochtaSearchOpsRequestQuery extends ActiveModel {

/**
  * PostalCode
  * Индекс ОПС.
  */
  @ActiveField()
  PostalCode?: string


  /**
  * UfpsPostalCode
  * Для поиска по индексу: учитывать УФПС (по умолчанию true).  */
  @ActiveField()
  UfpsPostalCode?: boolean


/**
  * Address
  * Строка адреса для поиска ближайших ОПС.
  */
  @ActiveField()
  Address?: string


  /**
  * Latitude
  *   */
  @ActiveField()
  Latitude?: number


  /**
  * Longitude
  *   */
  @ActiveField()
  Longitude?: number


  /**
  * Top
  * Максимальное число результатов (address / nearby).  */
  @ActiveField()
  Top?: number


  /**
  * SearchRadiusKm
  * Радиус поиска, км (nearby).  */
  @ActiveField()
  SearchRadiusKm?: number


  /**
  * HidePrivate
  * Исключать непубличные отделения (nearby).  */
  @ActiveField()
  HidePrivate?: boolean


  /**
  * FilterByOfficeType
  * Фильтр по типам ОПС (nearby).  */
  @ActiveField()
  FilterByOfficeType?: boolean
}
